
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./gallery.css";
import { Modal } from "react-bootstrap";

import img1 from "../decor/b/b(6).webp";
import img2 from "../decor/b/b(7).webp";
// import img3 from "../decor/b/b(8).webp";
import img4 from "../decor/b/b(5).webp";
import img5 from "../decor/b/b(15).webp";
import img6 from "../decor/b/b(16).webp";
import img7 from "../decor/b/b(17).webp";
import img8 from "../decor/b/b(18).webp";
import img9 from "../decor/b/b(2).webp";
import img10 from "../decor/b/b(3).webp";

import img11 from "../decor/c/bt1(1).webp";
import img12 from "../decor/c/bt1(2).webp";
import img13 from "../decor/c/bt1(3).webp";
import img14 from "../decor/c/bt1(4).webp";
import img15 from "../decor/c/bt1(5).webp";
import img16 from "../decor/c/bt1(6).webp";
import img17 from "../decor/c/bt1(7).webp";
import img18 from "../decor/c/bt1(8).webp";
import img19 from "../decor/c/bt1(9).webp";
import img20 from "../decor/c/bt1(10).webp";

import img23 from "../decor/d/a2.webp";
import img21 from "../decor/d/a4.webp";
import img22 from "../decor/d/b2.webp";
import img24 from "../decor/d/bt1(132).webp";
import img25 from "../decor/d/bt1(133).webp";
import img26 from "../decor/d/bt1(134).webp";
import img27 from "../decor/d/bt1(136).webp";
import img28 from "../decor/d/bt1(138).webp";

import img29 from "../decor/e/bt1(140).webp";
import img30 from "../decor/e/bt1(147).webp";
import img31 from "../decor/e/bt1(148).webp";
import img32 from "../decor/e/bt1(155).webp";
import img33 from "../decor/e/wb10.webp";
import img34 from "../decor/e/wb11.webp";
// import img35 from "../decor/e/wb12.webp";
import img36 from "../decor/e/wb15.webp";
import img37 from "../decor/e/wb16.webp";
import img38 from "../decor/e/wb18.webp";
import img39 from "../decor/e/wb17.webp";
import img40 from "../decor/e/wb3.webp";

import img41 from "../decor/f/ban5.webp";
import img42 from "../decor/f/wb2.webp";
import img43 from "../decor/f/wc(10).webp";
import img44 from "../decor/f/wc(11).webp";
import img45 from "../decor/f/wc(12).webp";
import img46 from "../decor/f/wc(13).webp";
import img47 from "../decor/f/wc(18).webp";
import img48 from "../decor/f/wc(3).webp";
import img49 from "../decor/f/wc(6).webp";
import img50 from "../decor/f/wc(7).webp";

import img51 from "../decor/h/wb1.webp";

import img52 from "../decor/i/pr(1).webp";
import img53 from "../decor/i/pr(10).webp";
import img54 from "../decor/i/pr(11).webp";
import img55 from "../decor/i/pr(12).webp";
import img56 from "../decor/i/pr(13).webp";
import img57 from "../decor/i/pr(14).webp";
import img58 from "../decor/i/pr(2).webp";
import img59 from "../decor/i/pr(3).webp";
import img60 from "../decor/i/pr(4).webp";
import img61 from "../decor/i/pr(5).webp";
import img62 from "../decor/i/pr(6).webp";

import img63 from "../decor/j/art1.webp";
import img64 from "../decor/j/tt(1).webp";
import img65 from "../decor/j/tt(2).webp";
import img66 from "../decor/j/tt(3).webp";
import img67 from "../decor/j/tt(4).webp";
import img68 from "../decor/j/tt(5).webp";
import img69 from "../decor/j/tt(6).webp";
import img70 from "../decor/j/tt(7).webp";
import img71 from "../decor/j/tt(8).webp";
import img72 from "../decor/j/tt(9).webp";
import img73 from "../decor/j/art1.webp";
import img74 from "../decor/j/tt(1).webp";

import img75 from "../decor/k/art1.webp";
import img76 from "../decor/k/art2.webp";
import img77 from "../decor/k/art3.webp";
import img78 from "../decor/k/art4.webp";
import img79 from "../decor/k/art5.webp";
import img80 from "../decor/k/art6.webp";

import img81 from "../decor/l/gm(1).webp";
import img82 from "../decor/l/gm(10).webp";
import img83 from "../decor/l/gm(2).webp";
import img84 from "../decor/l/gm(3).webp";
import img85 from "../decor/l/gm(4).webp";
import img86 from "../decor/l/gm(5).webp";
import img87 from "../decor/l/gm(7).webp";
import img88 from "../decor/l/gm(6).webp";
import img89 from "../decor/l/gm(8).webp";
import img90 from "../decor/l/gm(9).webp";

import img91 from "../decor/m/nl(1).webp";
import img92 from "../decor/m/nl(10).webp";
import img93 from "../decor/m/nl(2).webp";
import img94 from "../decor/m/nl(4).webp";
import img95 from "../decor/m/nl(5).webp";
import img96 from "../decor/m/nl(6).webp";
import img97 from "../decor/m/nl(8).webp";
import img98 from "../decor/m/nl(9).webp";

import img99 from "../decor/n/a (1).webp";
import img100 from "../decor/n/a (2).webp";
import img101 from "../decor/n/a (3).webp";
import img102 from "../decor/n/a (4).webp";
import img103 from "../decor/n/a (5).webp";
import img104 from "../decor/n/a (6).webp";
import img105 from "../decor/n/a (7).webp";
import img106 from "../decor/n/a (8).webp";

import img107 from "../decor/o/bt1(112).webp";
import img108 from "../decor/o/bt1(126).webp";
import img109 from "../decor/o/bt1(129).webp";
import img110 from "../decor/o/bt1(130).webp";
import img111 from "../decor/o/bt1(166).webp";
import img112 from "../decor/o/bt1(167).webp";
import img113 from "../decor/o/bt1(168).webp";
import img114 from "../decor/o/bt1(48).webp";
import img115 from "../decor/o/bt1(66).webp";
import img116 from "../decor/o/bt1(79).webp";
import img117 from "../decor/o/bt1(93).webp";
import img118 from "../decor/o/bt1(94).webp";

import img119 from "../decor/p/hl (1).webp";
import img120 from "../decor/p/hl (2).webp";
import img121 from "../decor/p/hl (3).webp";
import img122 from "../decor/p/hl (4).webp";
import img123 from "../decor/p/hl(1).webp";
import img124 from "../decor/p/hl(2).webp";
import img125 from "../decor/p/hl(4).webp";
import img126 from "../decor/p/hl(5).webp";
import img127 from "../decor/p/hl(6).webp";

import img128 from "../decor/q/wc(32).webp";
import img129 from "../decor/q/wc(33).webp";
import img130 from "../decor/q/wc(34).webp";
import img131 from "../decor/q/wc(35).webp";
import img132 from "../decor/q/wc(36).webp";
import img133 from "../decor/q/wc(37).webp";
import img134 from "../decor/q/wc(39).webp";
import img135 from "../decor/q/wc(40).webp";
import img136 from "../decor/q/wc(41).webp";
import img137 from "../decor/q/wc(42).webp";
import img138 from "../decor/q/wc(32).webp";

import img139 from "../decor/h/a (1).webp";
import img140 from "../decor/h/a (10).webp";
import img141 from "../decor/h/a (11).webp";
import img142 from "../decor/h/a (12).webp";
import img143 from "../decor/h/a (13).webp";
import img144 from "../decor/h/a (14).webp";
import img145 from "../decor/h/a (2).webp";
import img146 from "../decor/h/a (3).webp";
import img147 from "../decor/h/a (4).webp";
import img148 from "../decor/h/a (5).webp";
import img149 from "../decor/h/a (6).webp";
import img150 from "../decor/h/a (7).webp";

import img151 from "../decor/r/m1.webp";
import img152 from "../decor/r/m2.webp";
import img153 from "../decor/r/m3.webp";
import img154 from "../decor/r/m4.webp";
import img155 from "../decor/r/m5.webp";
import img156 from "../decor/r/magic.webp";
// import img157 from "../decor/r/m7.webp";
// import img158 from "../decor/r/m8.webp";
// import img159 from "../decor/r/m9.webp";
// import img160 from "../decor/r/m10.webp";

import img161 from "../decor/s/b1.webp";
import img162 from "../decor/s/b2.webp";
import img163 from "../decor/s/b3.webp";
import img164 from "../decor/s/b4.webp";
import img165 from "../decor/s/b5.webp";
// import img166 from "../decor/s/b6.webp";

import img167 from "../decor/t/t1.webp";
import img168 from "../decor/t/t2.webp";
import img169 from "../decor/t/t3.webp";
import img170 from "../decor/t/t4.webp";
import img171 from "../decor/t/t5.webp";
// import img172 from "../decor/t/t6.webp";

const Gallery = () => {
  const categories = ["All", "Birthday", "HomeDecoration", "BedroomDecoration", "BabyShower", "MarathiBabyShower", "NamingCeremony", "Disneyland", "BubbleShow", "TattoArt", "Caricature", "GameStall", "MagicShow", "ThemParty", "NailArt", "Mundan", "AdultBirthday", "HaldiMehndi", "WelcomeBaby"];
  const [activeCategory, setActiveCategory] = useState("All");

  const [selectedImage, setSelectedImage] = useState(null);

  const images = {
    All: [
      img1, img2, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18, img19, img20, img21, img22, img23, img24, img25, img26, img27, img28, img29, img30, img31, img32, img33, img34,img36, img37, img38, img39, img40, img41, img42, img43, img44, img45, img46, img47, img48, img49, img50, img51, img52, img53, img54, img55, img56, img57, img58, img59, img60, img61, img62,img64, img65, img66, img67, img68, img69, img70, img71, img72, img73, img74, img75, img76, img77, img78, img79, img80, img81, img82, img83, img84, img85, img86, img87, img88, img89, img90, img91, img92, img93, img94, img95, img96, img97, img98, img99, img100, img101,img104, img105, img106, img107, img108, img109, img110, img111, img112, img113, img114, img115, img116, img117, img118, img119, img120, img121, img122, img123, img124, img125, img126, img127, img128, img129, img30, img131, img132, img133, img134, img135, img136, img137, img138, img139, img140, img141, img142, img143, img144, img145, img146, img147, img148, img149, img150, img151, img152, img153, img154, img155, img156, img161, img162, img163, img164, img165, img167, img168, img169, img171,
    ],
    Birthday: [
      img1, img2, img4, img5, img6, img7, img8, img9, img10
    ],
    HomeDecoration: [
      img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
    ],
    BedroomDecoration: [
      img21, img22, img23, img24, img25, img26, img27, img28,
    ],
    BabyShower: [
      img29, img30, img31, img32, img33, img34,  img36, img37, img38, img39, img40, img30,
    ],
    MarathiBabyShower: [
      img41, img42, img43, img44, img45, img46, img47, img48, img49, img50,
    ],
    NamingCeremony: [
      img51, img139, img140, img141, img142, img143, img144, img145, img146, img147, img148, img150,
    ],
    Disneyland: [
      img52, img53, img54, img55, img56, img57, img58, img59, img60, img61, img62,
    ],
    TattoArt: [
      img63, img64, img65, img66, img67, img68, img69, img70, img71, img72, img73, img74,
    ],
    Caricature: [
      img75, img76, img77, img78, img79, img80,
    ],
    GameStall: [
      img81, img82, img83, img84, img85, img86, img87, img88, img89, img90,
    ],
    NailArt: [
      img91, img92, img93, img94, img95, img96, img97, img98,
    ],
    Mundan: [
      img99, img100, img102, img103, img104, img105,
    ],
    AdultBirthday: [
      img107, img109, img110, img111, img112, img113, img114, img115, img116, img117,
      img118
    ],
    HaldiMehndi: [
      img119, img120, img121, img122, img123, img124, img125, img126, img127,
    ],
    WelcomeBaby: [
      img129, img131, img132, img133, img134, img135, img136, img137, img138,
    ],
    MagicShow: [
      img151, img152, img153, img154, img155, img156,
    ],
    BubbleShow: [
      img161, img162, img163, img164, img165,
    ],
    ThemParty: [
      img167, img168, img169, img171,
    ],
  };

  return (
    <>
      <div class="p-4 breadcrumb-container">
        <ol class="breadcrumb text-center">
          <li class="breadcrumb-item"><a href="/">Home</a></li>
          <li class="breadcrumb-item"><a href="#">Gallery</a></li>
        </ol>
      </div>

      <div
        className="container text-center g-nav" id="gallery"
        style={{
          // backgroundColor: "#f8f9fa",
          borderRadius: "10px",
          // border: "2px solid #dee2e6",
        }}
      >

        {/* Responsive Navbar */}
        <nav className="navbar navbar-expand-md navbar-light bg-white mb-4">
          <div className="container-fluid">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#galleryNavbar"
              aria-controls="galleryNavbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse justify-content-start"
              id="galleryNavbar"
            >
              <div className="d-flex flex-wrap gap-2">
                {categories.map((category) => (
                  <button
                    key={category}
                    className={`btn ${activeCategory === category
                      ? "btn g-btn"
                      : "btn-outline g-btn"
                      }`}
                    onClick={() => setActiveCategory(category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </nav>

        {/* Image Grid */}

        <div
          className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3 overflow-auto p-3"
          style={{
            maxHeight: "500px",
            borderRadius: "8px",
            backgroundColor: "#ffffff",
          }}
        >
          {images[activeCategory].map((img, index) => (
            <div className="col" key={index}>
              <img
                src={img}
                alt={activeCategory}
                className="img-fluid rounded shadow-sm border"
                style={{
                  borderColor: "#adb5bd",
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedImage(img)}
              />
            </div>
          ))}

          {/* Modal for Image Zoom */}
          <Modal show={!!selectedImage} onHide={() => setSelectedImage(null)} centered>
            <Modal.Body className="text-center">
              {selectedImage && (
                <img src={selectedImage} alt="Zoomed" className="img-fluid rounded" />
              )}
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Gallery;
